import React, { useState } from "react";
import UseTable from "../../components/table/useTable";
import { useTranslation } from "react-i18next";
import globalStyles from "../../style/global.js";
import useStyles from "./usersStyle";

import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import { getUsersData } from "../../redux/reduser/users";
import ErrorMessage from "../../components/errorMessage/ErrorMessage";
import CircularProgressBar from "../../components/circularProgress/CircularProgress";

import { Box } from "@mui/material";

import PageTitle from "../../components/pageTitle/PageTitle";
function Users() {
  const { t } = useTranslation();
  const classes = useStyles();
  const globalClasses = globalStyles();
  const { data, loading, error } = useSelector((state) => state.users);


  
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getUsersData());
  }, []);

  const columns = [
    { name: t("id") },
    { name: t("userName") },
    { name: t("email") },
    { name: t("phone") },
    
  ];

  return (
    <Box className={globalClasses.background}>
    <Box className={globalClasses.page}>
    <Box className={globalClasses.row}>
     <PageTitle title={t("users")}/>
   
       
    </Box>
    <Box >
    
      {loading === true ? (
        <div className={globalClasses.center}>
          {" "}
          <CircularProgressBar />{" "}
        </div>
      ) : error == null ? (
        <UseTable
          data={data}
          columns={columns}
          title={t("users")}
          selectableRows={false}
        />
      ) : (
        <div className={globalClasses.center}>
          {" "}
          <ErrorMessage title={error} />{" "}
        </div>
      )}
    </Box>
    
    </Box>
    </Box>
  );
}
export default Users;
